import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NoRolesDialogComponent } from './notifications/no-roles/no-roles-dialog/no-roles-dialog.component';
import { NoRolesDialogBodyComponent } from './notifications/no-roles/no-roles-dialog-body/no-roles-dialog-body.component';
import { MaterialModule } from '../material/material.module';

@NgModule({
    declarations: [NoRolesDialogComponent, NoRolesDialogBodyComponent],
    imports: [CommonModule, MaterialModule],
    entryComponents: [NoRolesDialogComponent, NoRolesDialogBodyComponent],
    exports: [NoRolesDialogComponent, NoRolesDialogBodyComponent]
})
export class AuthorizationModule {}
